// extracted by mini-css-extract-plugin
export var anticlockwise = "ck_kJ";
export var svg = "ck_kG";
export var wrapper = "ck_B";
export var wrapperFlexCenter = "ck_kH";